import { signal } from "@preact/signals-react";

import { loadReportShiftContext, type ShiftInstance } from "@/shared/api/api-client";
import { getHospitalPeriodValue } from "@/shared/utils/hospital-time";

export const activeShiftInstanceID = signal<string | null>(null);
export const availableShiftInstances = signal<ShiftInstance[]>([]);
export const shiftContextError = signal<string | null>(null);

export async function refreshActiveShift(cancelled: () => boolean = () => false) {
    try {
        const context = await loadReportShiftContext(getHospitalPeriodValue());
        if (cancelled()) return;
        availableShiftInstances.value = context.instances;
        activeShiftInstanceID.value = resolveActiveShiftInstanceID(context.instances, new Date(context.now));
        shiftContextError.value = null;
    } catch {
        if (cancelled()) return;
        activeShiftInstanceID.value = null;
        availableShiftInstances.value = [];
        shiftContextError.value = "Unable to load the comment shift. Retry before saving.";
    }
}

export function resolveActiveShiftInstanceID(instances: ShiftInstance[], now = new Date()) {
    const official = instances.find((instance) => now >= new Date(instance.official_start) && now < new Date(instance.official_end));
    if (official) return official.id;

    const flexible = instances.find((instance) => now >= new Date(instance.maximum_start) && now < new Date(instance.maximum_end));
    return flexible?.id ?? null;
}
